export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'shuimian-fangsong',
    name: '助眠放松',
    description: '专为失眠人群打造的深度放松ASMR内容，帮助您在温柔的声音中安然入睡',
    icon: 'ri-moon-line',
    articleCount: 48,
    imageSeq: 'cat-sleep-01',
  },
  {
    slug: 'eryu-peiban',
    name: '耳语陪伴',
    description: '温柔的耳语、轻声细语，为您带来最贴心的情感陪伴体验',
    icon: 'ri-user-voice-line',
    articleCount: 36,
    imageSeq: 'cat-whisper-01',
  },
  {
    slug: 'chufa-yinxiao',
    name: '触发音效',
    description: '敲击、摩擦、翻页等各类触发音，满足您对ASMR的所有想象',
    icon: 'ri-sound-module-line',
    articleCount: 52,
    imageSeq: 'cat-trigger-01',
  },
  {
    slug: 'jiaose-banyan',
    name: '角色扮演',
    description: '沉浸式的角色扮演ASMR体验，带您进入各种奇妙的场景世界',
    icon: 'ri-magic-line',
    articleCount: 29,
    imageSeq: 'cat-roleplay-01',
  },
  {
    slug: 'meishi-jujiao',
    name: '美食咀嚼',
    description: '酥脆、Q弹、多汁，各类美食ASMR声音带来的极致听觉享受',
    icon: 'ri-restaurant-line',
    articleCount: 34,
    imageSeq: 'cat-food-01',
  },
  {
    slug: 'baizaoyin',
    name: '环境白噪音',
    description: '雨声、海浪、森林、篝火...来自大自然最纯净的白噪音合集',
    icon: 'ri-landscape-line',
    articleCount: 41,
    imageSeq: 'cat-noise-01',
  },
];